import src from "IMAGE";
export default { src, width: 464, height: 128, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAP0lEQVR42l3IoREAEBQA0B8EfBR3zjpO4kQLaLpuANEAVrCiQvHiA7iQo3I+15TnYmgN/AhhNMbSRwtbCq7fH+X7BzgvnIGhAAAAAElFTkSuQmCC"};
